// Word Wheel puzzles for Italian.
// letters: the seven tiles. words: common words to find (shown in the count). extra: other valid words, accepted as bonus.
// Checked against a spelling dictionary, so no word needs to be verified while playing.

export const WHEEL_IT = [
    {
        letters: 'ettsorp',
        words: 'ero ore per perso però peso pesto petto porte pose poste poter preso presto pro reso resto retto rotte sorte spero spettro sto teso testo torte tre',
        extra: 'epos erto estro etto orte oste osé otre peto por porse pretto reo setto spett spore storte terso tetro toste trote',
    },
    {
        letters: 'neziacl',
        words: 'alzi anzi cali calze cane cani cela cena clan lance lanci lei licenza linea nei nel zia',
        extra: 'aie alce alci ance ani anice cale calzi canile celi celia ceni ciel cilena cli eia elci elica iena ila ile inca lanzi lenci lenza liane lince zane zie',
    },
    {
        letters: 'olrclea',
        words: 'alcol alle allo arco calo calore caro cella cera clero col cola colla collare colle collera corea crea creò eco ella era ero locale ora orale ore reca recò',
        extra: 'acero acro alce alo aloe areo aro cale calle callo cela celo cero colare colera corale creola crolla lacero loca lor oca ocra ocre ola olla ollare olle orca orla rallo rea reo roca rolla',
    },
    {
        letters: 'taubnri',
        words: 'arti bar brani bruna bruni buia nati nubi ruba rubati tabù tira tra tribuna tribù tua tubi turba turbina turni una unità urbani urina',
        extra: 'ani antri ari atri auri bai bina brina brut bruta bruti bui buna ira irta iuta nari nubia nutra nutri nutria ria rin rubai rubi runa ruta tani tari tau tauri tir trai tria trina tuba tuia tura turbi turi unirà unta unti urbi uri uria urna urta urti',
    },
    {
        letters: 'irpotom',
        words: 'importo mio mito moro morti morto morì moto motori oro orto pio poi porti porto potrò primo pro promo rio ritmo rito tipo tiro topi topo toro trio',
        extra: 'impor irto mir miro mirto moti omo opti opto ori orti piro pomi pomo por pori pormi poro poti proto rompi rompo timo timor tir tomi tomo topoi tori torio tropi tropo',
    },
    {
        letters: 'nomiacb',
        words: 'amico amo animo baci bacino bacio banco bianco cambi cambino cambio camion cani ciao cibo cima ciò coi combina mai manco mani mano mia mica mio monaci noi noia nomi',
        extra: 'acino aio ambi ambo ani ano baco bai baio bano bina bino boa boia boma bona camino ciano ciba cibano cmi coma comi coni conia icona ima inca manico mao miao mina mino moca monca nico nimbo noci noma obi oca omnia oncia',
    },
    {
        letters: 'curiatn',
        words: 'acri acuti arti cani canti cari carni cinta cintura cita cui cura curati curia nati nuca taci tira tra tua turca turni una unica unità urina',
        extra: 'ani antri ari atri auri canuti cauti crani crauti cri cruna cuna curanti curi inca ira irta iuta nari nutra nutri nutria ria rin runa ruta tac tani tari tau tauri tic tinca tir trac traci trai tranci tria tric trina trinca tuia tunica tura turi unirà unta unti urca uri uria urna urta urti',
    },
    {
        letters: 'tsrooit',
        words: 'oro orsi orso orti orto otto rio riso risotto rito rotti rotto sito sorti sorto sotto sto storto tiro tori toro torti torto tosi tosto trio',
        extra: 'irto ori osi oso osti ostro risto ritto rosi roso sori soro sortito stiro storti tir tirso torio torso toso tosti tris tristo trito',
    },
    {
        letters: 'iiattsr',
        words: 'arti artisti atti iris ratti riti sai sia sita siti sta stai stati stia strati tasti tira tirati tiri tra tristi',
        extra: 'ari arsi asi astri atri attiri ira irta irti rais rasi ria rii risa risi ritti sarti satiri sii stari starti stira stirati stiri stiria stria striati tari tarsi tir tirai tisi trai tria tris trista trita triti',
    },
    {
        letters: 'ertecod',
        words: 'cede certe certo ceto corde corte crede credo creò decreto dote eco ero eroe etero ore recò rete tre',
        extra: 'cederò cedo cedro cere cero coree dee ere erode erto ocre ode orde orte otre recto reo tede torce',
    },
    {
        letters: 'ogegrle',
        words: 'ergo ero eroe gelo gergo gol legge leggero leggo lego ore regge regole',
        extra: 'egeo ego ere erg erge geo gole legger logge lor orge reggo relè reo rogge',
    },
    {
        letters: 'tolavne',
        words: 'alte alto età lato lenta lento leva nate nato nave nel neo nota note nove ove tal tale tela vale velo vena vento vola volante volta volte vota',
        extra: 'alo aloe alt alveo alvo aneto ano ante ateo ave avo evo lave lavo levano levato levo nevo nova ola onta ovale tane tavole teano telo tena tona tonale valo vane vano vanto vate vela velato venato ventola veto volate vole volt',
    },
];